import { LeanIconsModule } from './../lean-icons/lean-icons.module';
import { NzTagModule } from 'ng-zorro-antd/tag';
import {
	PasswordStrengthIndicatorComponent
} from './components/password-strength-indicator/password-strength-indicator.component';
import { DeclineRequestComponent } from './components/decline-request/decline-request.component';
import { ViewAccessDirective } from '../shared/directives/view-access.directive';
import { EventCountDownTimerUtil } from '../shared/utils/event-countdown-timer';
import { ModalService } from './components/nz-modal-service/modal.service';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzModalServiceComponent } from './components/nz-modal-service/nz-modal-service.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { EncryptionUtil } from '../shared/utils/encryption.util';
import { MobileDeviceDirective } from '../shared/directives/mobile-device.directive';
import { LargeDeviceDirective } from '../shared/directives/large-device.directive';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { CustomSubmitButtonComponent } from './components/custom-submit-button/custom-submit-button.component';
import { AuthoritiesConfig, RoutesGaurdConfig } from '../shared/config/authorities-config';
import { LoadingComponent } from './components/loading/loading.component';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { PaginationComponent } from './components/pagination/pagination.component';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { AlertComponent } from './components/alert/alert.component';
import { CustomErrorDisplayComponent } from './components/custom-error-display/custom-error-display.component';
import { StepsComponent } from './components/steps/steps.component';
import { TranslateModule } from '@ngx-translate/core';
import { OtpComponent } from './components/otp/otp.component';
import { InputControlComponent } from './components/input-control/input-control.component';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { TransactionDetailComponent } from './components/transaction-detail/transaction-detail.component';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { WalletFilterModalComponent } from './components/wallet-filter-modal/wallet-filter-modal.component';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NonModalAlertComponent } from './components/non-modal-alert/non-modal-alert.component';
import { DeviceOtpComponent } from './components/device-otp/device-otp.component';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { TimelineComponent } from './components/timeline/timeline.component';
import { BaseFormComponent } from './components/base-form/base-form.component';
import { SelectOptionsControlComponent } from './components/select-options-control/select-options-control.component';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NgxImageCompressService } from 'ngx-image-compress';
import { FeatureAccessDirective } from '../shared/directives/feature-access.directive';
import { NgxCaptureModule } from 'ngx-capture';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { LoanApprovalCountdownComponent } from './components/loan-approval-countdown/loan-approval-countdown.component';
import { WebcamModule } from 'ngx-webcam';
import { LivelinessWebcamComponent } from './components/liveliness-webcam/liveliness-webcam.component';
import { LivelinessComponent } from './components/liveliness/liveliness.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { BreakDownDetailsComponent } from './components/break-down-details/break-down-details.component';
import { BonazaDetailsComponent } from './components/bonaza-details/bonaza-details.component';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { MerchantTableComponent } from './components/kamona-components/merchant-table/merchant-table.component';
import { AlertMessageComponent } from './components/alert-message/alert-message.component';
import { AttachmentComponent } from './components/attachment/attachment.component';
import { CustomButtonComponent } from './components/custom-button/custom-button.component';
import { InsuranceAlertBannerComponent } from './components/insurance-alert-banner/insurance-alert-banner.component';
import {
	MoniepointCheckBoxComponent
} from './components/kamona-components/moniepoint-check-box/moniepoint-check-box.component';
import {
	MoniepointNotificationComponent
} from './components/kamona-components/moniepoint-notification/moniepoint-notification.component';
import { OtpInputComponent } from './components/otp-input/otp-input.component';
import { OtpSuspensionDisplayComponent } from './components/otp-suspension-display/otp-suspension-display.component';
import { PosConfigFeaturesComponent } from './components/pos-config-features/pos-config-features.component';
import { PosConfigComponent } from './components/pos-config/pos-config.component';
import { TerminalDetailAlertComponent } from './components/terminal-detail-alert/terminal-detail-alert.component';
import { TimerCountdownComponent } from './components/timer-countdown/timer-countdown.component';
import { MoniepointCarouselDirective } from '../shared/directives/moniepoint-carousel.directive';
import { CustomFaceCaptureComponent } from './components/custom-face-capture/custom-face-capture.component';
import { CustomImageUploaderComponent } from './components/custom-image-uploader/custom-image-uploader.component';
import { FloatingLabelInputComponent } from './components/floating-label-input/floating-label-input.component';
import {
	MerchantDesktopTableComponent
} from './components/kamona-components/merchant-table/merchant-desktop-table/merchant-desktop-table.component';
import {
	MerchantMobileTableComponent
} from './components/kamona-components/merchant-table/merchant-mobile-table/merchant-mobile-table.component';
import {
	MerchantTableColumnComponent
} from './components/kamona-components/merchant-table/merchant-table-column/merchant-table-column.component';
import { MoniepointTableComponent } from './components/kamona-components/moniepoint-table/moniepoint-table.component';
import {
	MoniepointTableSpecialColumnComponent
} from './components/kamona-components/moniepoint-table/partials/moniepoint-table-special-column/moniepoint-table-special-column.component';
import {
	CustomInputBorderValidationErrorDirective
} from '../shared/directives/custom-input-border-validation-error.directive';
import { CustomSelectDirective } from '../shared/directives/custom-select.directive';
import {
	KamonaAlertBannerComponent
} from './components/kamona-components/kamona-alert-banner/kamona-alert-banner.component';
import { MoniepointAmountComponent } from './components/kamona-components/moniepoint-amount/moniepoint-amount.component';
import {
	MoniepointBalanceBoardComponent
} from './components/kamona-components/moniepoint-balance-board/moniepoint-balance-board.component';
import {
	MoniepointBeneficiaryComponent
} from './components/kamona-components/moniepoint-beneficiary/moniepoint-beneficiary.component';
import {
	BeneficiaryModalComponent
} from './components/kamona-components/moniepoint-beneficiary/partials/beneficiary-modal/beneficiary-modal.component';
import {
	MoniepointBreadcrumbComponent
} from './components/kamona-components/moniepoint-breadcrumb/moniepoint-breadcrumb.component';
import {
	MoniepointConfirmModalComponent
} from './components/kamona-components/moniepoint-confirm-modal/moniepoint-confirm-modal.component';
import {
	MoniepointFailureModalComponent
} from './components/kamona-components/moniepoint-failure-modal/moniepoint-failure-modal.component';
import {
	MoniepointPendingModalComponent
} from './components/kamona-components/moniepoint-pending-modal/moniepoint-pending-modal.component';
import {
	MoniepointSuccessModalComponent
} from './components/kamona-components/moniepoint-success-modal/moniepoint-success-modal.component';
import { KamonaSwitchComponent } from './components/kamona-components/kamona-switch/kamona-switch.component';
import {
	KamonaTableFilterComponent
} from './components/kamona-components/kamona-table-filter/kamona-table-filter.component';
import { TimeSelectComponent } from './components/time-select/time-select.component';
import { MoniepointDialogComponent } from './components/kamona-components/moniepoint-dialog/moniepoint-dialog.component';
import {
	MoniepointStepperComponent
} from './components/kamona-components/moniepoint-stepper/moniepoint-stepper/moniepoint-stepper.component';
import {
	MoniepointStepperContentComponent
} from './components/kamona-components/moniepoint-stepper/moniepoint-stepper-content/moniepoint-stepper-content.component';
import {
	ContentWrapperComponent
} from './components/kamona-components/moniepoint-stepper/moniepoint-stepper-content/content-wrapper/content-wrapper.component';
import { dynamicComponentDirective } from '../shared/directives/dynamic-component.directive';
import { HorizontalStepsComponent } from './components/horizontal-steps/horizontal-steps.component';
import {
	KamonaFloatingButtonComponent
} from './components/kamona-components/kamona-floating-button/kamona-floating-button.component';
import { FloatingLabelSelectDirective } from './directives/floating-label-select.directive';
import { KamonaOtpCountDownComponent } from './components/kamona-otp-count-down/kamona-otp-count-down.component';
import { KamonaCustomDialogComponent } from './components/kamona-components/kamona-dialog/kamona-custom-dialog.component';
import {
	KamonaDialogAlertComponent
} from './components/kamona-components/kamona-dialog-alert/kamona-dialog-alert.component';
import { IconsModule } from '../icons/icons.module';
import {
	WorkingCapitalWarningBannerComponent
} from './components/working-capital-warning-banner/working-capital-warning-banner.component';
import {
	WorkingCapitalUploadInputComponent
} from './components/working-capital-upload-input/working-capital-upload-input.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import {
	WorkingCapitalLoanDropdownItemComponent
} from './components/working-capital-loan-dropdown-item/working-capital-loan-dropdown-item.component';
import { MpCameraComponent } from './components/mp-camera/mp-camera.component';
import {
	WlcCameralModalComponent
} from './components/working-capital-upload-input/modal/wlc-cameral-modal/wlc-cameral-modal.component';
import { YearlyReviewBannerComponent } from './components/yearly-review-banner/yearly-review-banner.component';
import {
	YearlyReviewReportModalComponent
} from './components/yearly-review-banner/yearly-review-report-modal/yearly-review-report-modal.component';
import { UtilitiesModule } from '../utilities/utilities.module';
import {
	LegalTermsAndConditionsModalComponent
} from './components/legal-terms-and-conditions-modal/legal-terms-and-conditions-modal.component';
import {
	DailyLimitWarningComponent
} from './components/kamona-components/moniepoint-beneficiary/partials/daily-limit-warning/daily-limit-warning.component';
import {
	TransferInfoCardComponent
} from './components/kamona-components/moniepoint-beneficiary/partials/transfer-info-card/transfer-info-card.component';
import {
	ManageBeneficiariesComponent
} from './components/kamona-components/moniepoint-beneficiary/partials/manage-beneficiaries/manage-beneficiaries.component';
import {
	AddBeneficiaryComponent
} from './components/kamona-components/moniepoint-beneficiary/partials/manage-beneficiaries/add-beneficiary/add-beneficiary.component';
import {
	EditTransactionLimitModalComponent
} from './components/kamona-components/moniepoint-beneficiary/partials/edit-transaction-limit-modal/edit-transaction-limit-modal.component';
import { SetBusinessPinComponent } from './components/set-business-pin/set-business-pin.component';
import { SetBusinessPinModalComponent } from './components/set-business-pin-modal/set-business-pin-modal.component';
import { KamonaModule } from '../kamona/kamona.module';
import { UserPinComponent } from './components/user-pin/user-pin.component';
import { DeclineRequestModalComponent } from './components/decline-request-modal/decline-request-modal.component';
import { GenericDropdownModalComponent } from './components/generic-dropdown-modal/generic-dropdown-modal.component';
import { UserPinSetupModalComponent } from './components/user-pin-setup-modal/user-pin-setup-modal.component';
import { PdfViewerModule } from "ng2-pdf-viewer";
import { GeneralTermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { AccountsClosedModalComponent } from './components/accounts-closed-modal/accounts-closed-modal.component';
import { ClickOutsideDirective } from '../shared/directives/click-outside.directive';
import { DocumentSampleModalComponent } from './components/document-sample-modal/document-sample-modal.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { SwapValidationFailureComponent } from './components/kamona-components/swap-validation-failure/swap-validation-failure.component';
import { OptionalDescriptionDirective } from './directives/optional-description.directive';
import { LazyReactComponentDirective } from './directives/lazy-react-component.directive';
import { AssignTerminalComponent } from '../aggregator-agent/components/assign-terminal/assign-terminal.component';
import { IconsProviderModule } from '../icons/icons-provider.module';
import { PricingComponent } from '../aggregator-agent/components/pricing-main/partials/pricing/pricing.component';
import { PricingListComponent } from '../aggregator-agent/components/pricing-main/partials/pricing-list/pricing-list.component';
import { PricingInfoComponent } from '../aggregator-agent/components/pricing-main/partials/modals/pricing-info/pricing-info.component';
import { PricingRequestApprovalStepsComponent } from '../aggregator-agent/components/pricing-main/partials/pricing-request-approval-steps/pricing-request-approval-steps.component';
import { PricingTypeIconComponent } from '../aggregator-agent/components/pricing-main/partials/pricing-type-icon/pricing-type-icon.component';
import { HeroSectionComponent } from '../shared/components/hero-section/hero-section.component';
import { AddOutletComponent } from '../shared/components/outlets/add-outlet/desktop/add-outlet.component';
import { AddOutletMobileComponent } from '../shared/components/outlets/add-outlet/mobile/add-outlet-mobile.component';
import { ReactMfeWrapperComponent } from './components/react-mfe-wrapper/react-mfe-wrapper.component';
import { BusinessTypesComponent } from '../aggregator-agent/components/business-types/business-types.component';
import { BusinessCategorizationV3Component } from '../aggregator-agent/components/business-categorization-v3/business-categorization-v3.component';

const directives = [
	FeatureAccessDirective,
	MobileDeviceDirective,
	LargeDeviceDirective,
	ViewAccessDirective,
	CustomSelectDirective,
	CustomInputBorderValidationErrorDirective,
	dynamicComponentDirective,
	FloatingLabelSelectDirective,
	ClickOutsideDirective,
	OptionalDescriptionDirective,
	LazyReactComponentDirective,
];
const components = [
	CustomSubmitButtonComponent,
	// EmptyStateComponent,
	NzModalServiceComponent,
	LoadingComponent,
	PaginationComponent,
	AddOutletComponent,
	AddOutletMobileComponent,
	AlertComponent,
	CustomErrorDisplayComponent,
	// CustomAreaCoverageErrorComponent,
	StepsComponent,
	OtpComponent,
	InputControlComponent,
	TransactionDetailComponent,
	WalletFilterModalComponent,
	NonModalAlertComponent,
	DeviceOtpComponent,
	TimelineComponent,
	BaseFormComponent,
	SelectOptionsControlComponent,
	LoanApprovalCountdownComponent,
	LivelinessWebcamComponent,
	LivelinessComponent,
	BreakDownDetailsComponent,
	BonazaDetailsComponent,
	DeclineRequestComponent,
	MerchantTableComponent,
	MerchantDesktopTableComponent,
	MerchantMobileTableComponent,
	MerchantTableColumnComponent,
	AssignTerminalComponent,
	PricingComponent,
	PricingListComponent,
	PricingInfoComponent,
	PricingRequestApprovalStepsComponent,
	PricingTypeIconComponent,
	HeroSectionComponent,
	FloatingLabelInputComponent,
	CustomImageUploaderComponent,
	CustomFaceCaptureComponent,
	CustomInputBorderValidationErrorDirective,

	PasswordStrengthIndicatorComponent,
	MoniepointTableComponent,
	MoniepointTableSpecialColumnComponent,
	KamonaAlertBannerComponent,
	MoniepointBreadcrumbComponent,
	MoniepointBalanceBoardComponent,
	KamonaSwitchComponent,
	MoniepointSuccessModalComponent,
	MoniepointPendingModalComponent,
	MoniepointFailureModalComponent,
	KamonaTableFilterComponent,
	MoniepointConfirmModalComponent,
	TimeSelectComponent,
	MoniepointBeneficiaryComponent,
	BeneficiaryModalComponent,
	MoniepointAmountComponent,
	CustomButtonComponent,
	MoniepointNotificationComponent,
	OtpSuspensionDisplayComponent,
	PosConfigComponent,
	PosConfigFeaturesComponent,
	MoniepointCheckBoxComponent,
	TerminalDetailAlertComponent,
	TimerCountdownComponent,
	MoniepointCarouselDirective,
	// RemoveDashPipe,
	InsuranceAlertBannerComponent,
	AlertMessageComponent,
	AttachmentComponent,
	OtpInputComponent,
	MoniepointDialogComponent,
	MoniepointStepperComponent,
	MoniepointStepperContentComponent,
	HorizontalStepsComponent,
	KamonaCustomDialogComponent,
	KamonaDialogAlertComponent,
	WorkingCapitalWarningBannerComponent,
	WorkingCapitalUploadInputComponent,
	WorkingCapitalLoanDropdownItemComponent,
	MpCameraComponent,
	YearlyReviewBannerComponent,
	YearlyReviewReportModalComponent,
	DailyLimitWarningComponent,
	TransferInfoCardComponent,
	ManageBeneficiariesComponent,
	AddBeneficiaryComponent,
	SetBusinessPinComponent,
	SetBusinessPinModalComponent,
	UserPinComponent,
	DeclineRequestModalComponent,
	UserPinSetupModalComponent,
	AccountsClosedModalComponent,
	AvatarComponent,
	SwapValidationFailureComponent,
	DocumentSampleModalComponent,
	ReactMfeWrapperComponent,
	BusinessTypesComponent,
	BusinessCategorizationV3Component
];

@NgModule({
	declarations: [
		...directives,
		...components,
		ContentWrapperComponent,
		FloatingLabelSelectDirective,
		KamonaFloatingButtonComponent,
		KamonaOtpCountDownComponent,
		WlcCameralModalComponent,
		LegalTermsAndConditionsModalComponent,
		EditTransactionLimitModalComponent,
		GenericDropdownModalComponent,
		GeneralTermsConditionsComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		NzFormModule,
		NzButtonModule,
		NzInputModule,
		NzCheckboxModule,
		NzLayoutModule,
		NzTypographyModule,
		NzMenuModule,
		IconsProviderModule,
		NzBreadCrumbModule,
		NzAlertModule,
		NzMessageModule,
		NzSpinModule,
		NzModalModule,
		RouterModule,
		NzCollapseModule,
		NzSelectModule,
		ReactiveFormsModule,
		NzStatisticModule,
		NzProgressModule,
		NzInputNumberModule,
		NzTabsModule,
		NzSkeletonModule,
		TranslateModule,
		NzPopoverModule,
		NzDatePickerModule,
		NzTableModule,
		NzCardModule,
		NzDividerModule,
		NzListModule,
		NzPaginationModule,
		NzDropDownModule,
		NzBadgeModule,
		NzSwitchModule,
		NzTimelineModule,
		NzRateModule,
		NzImageModule,
		NzUploadModule,
		NzCarouselModule,
		NgxCaptureModule,
		NzTimePickerModule,
		NzPopconfirmModule,
		NzRadioModule,
		WebcamModule,
		NzToolTipModule,
		NzSliderModule,
		NzDrawerModule,
		NzTagModule,
		LeanIconsModule,
		ScrollingModule,
		IconsModule,
		UtilitiesModule,
		KamonaModule,
		PdfViewerModule
	],
	exports: [
		CommonModule,
		FormsModule,
		NzFormModule,
		NzButtonModule,
		NzInputModule,
		NzCheckboxModule,
		NzLayoutModule,
		NzTypographyModule,
		NzMenuModule,
		IconsProviderModule,
		NzBreadCrumbModule,
		NzAlertModule,
		NzMessageModule,
		NzSpinModule,
		NzModalModule,
		NzCollapseModule,
		NzSelectModule,
		ReactiveFormsModule,
		NzStatisticModule,
		NzProgressModule,
		NzInputNumberModule,
		NzTabsModule,
		TranslateModule,
		NzSkeletonModule,
		NzPopoverModule,
		NzDatePickerModule,
		NzTableModule,
		NzCardModule,
		NzDividerModule,
		NzListModule,
		NzPaginationModule,
		NzDropDownModule,
		NzBadgeModule,
		NzSwitchModule,
		NzTimelineModule,
		NzRateModule,
		NzStepsModule,
		NzImageModule,
		NzUploadModule,
		NzCarouselModule,
		NgxCaptureModule,
		NzTimePickerModule,
		NzPopconfirmModule,
		NzRadioModule,
		NzDrawerModule,
		WebcamModule,
		NzToolTipModule,
		NzTagModule,
		NzSliderModule,
		LeanIconsModule,
		ScrollingModule,
		OtpSuspensionDisplayComponent,
		TimerCountdownComponent,
		MoniepointSuccessModalComponent,
		MoniepointPendingModalComponent,
		PdfViewerModule,
		...components,
		...directives,
	],
	providers: [
		AuthoritiesConfig,
		RoutesGaurdConfig,
		ModalService,
		NgxImageCompressService,
		{ provide: NZ_I18N, useValue: en_US },
		{
			provide: DEFAULT_CURRENCY_CODE,
			useValue: '',
		},
		EncryptionUtil,
		EventCountDownTimerUtil,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LeanSharedModule {
}
